module.exports = __webpack_public_path__ + "51eda59a7901e22671a75d0d8a901b8e.png";